/* Vue HELPER functions */
/**
 * TODO: missing proper documentation in head
 *
 */

(function () {
	// /JSON stringifies every argument so the values are shown instead of the functions to the values...
	window.vuelog = function () {
		const arr = [];
		for (let i in arguments) {
			arr.push(JSON.parse(JSON.stringify(arguments[i])));
		}
		console.log(...arr);
	};

	window.cloneObject = function (obj) {
		// console.log('cloneObject', obj);
		if (obj) {
			return JSON.parse(JSON.stringify(obj));
		}
		return null;
	};
	window.JSONOREMPTY = function (str) {
		try {
			return JSON.parse(str);
		} catch (ex) {
			return {};
		}
	};

	window.formatHtmlInTextarea = function (node, level) {
		const indentBefore = new Array(level++ + 1).join('\t');

		const indentAfter = new Array(level - 1).join('\t');

		let textNode;

		for (let i = 0; i < node.children.length; i++) {
			textNode = document.createTextNode(`\n${indentBefore}`);
			node.insertBefore(textNode, node.children[i]);

			formatHtmlInTextarea(node.children[i], level);

			if (node.lastElementChild == node.children[i]) {
				textNode = document.createTextNode(`\n${indentAfter}`);
				node.appendChild(textNode);
			}
		}
		// console.log(level, node);
		return node;
	};

	if ($('#nominowui-version').length > 0) {
		$('#nominowui-version').click(function () {
			window.sessionStorage.clear();
			window.initToast('session storage cleared', 'success');
		});
		if (sessionStorage.getItem('nominow-buildstring') == null) {
			GET('/__build.txt').then(
				xhr => {
					sessionStorage.setItem('nominow-buildstring', xhr.responseText);
					$('#nominowui-version').text(xhr.responseText);
				},
				() => {
					sessionStorage.setItem('nominow-buildstring', 'localhost');
					$('#nominowui-version').text('localhost');
				}
			);
		} else {
			$('#nominowui-version').text(sessionStorage.getItem('nominow-buildstring'));
		}
	}
	Vue.component('nominow-readonly-text', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: ['value', 'label', 'name', 'css'],
		template: `
    <div class="mui-textfield">
    <span :class="css">{{value}}</span>
    <label>{{label}}</label>
    </div>
    `
	});

	// /VALIDATION SETUP
	(function ($) {
		function customValidation () {
			const $el = $(this);
			let name = $el.attr('name');
			if (name == null) {
				name = $el.attr('id');
			}
			if (name == null || name == '') {
				console.error("No 'id' or 'name' attribute on item to validate", $el);
			}
			if ($(`[data-valmsg-for="${name}"]`).length == 0) {
				// append error span after
				$el.after(`<span data-valmsg-for="${name}" class="mui-form-helper validation-message"></span>`);
			}
			// reset text message to nothing
			$(`[data-valmsg-for="${name}"]`).text('');
			$el.closest('div').removeClass('validation-error');

			if ($el.data('val-required') && !$el.val()) {
				$el.closest('div').addClass('validation-error');
				$(`[data-valmsg-for="${name}"]`).text($el.data('val-required'));
			} else if ($el.data('val-regex-pattern')) {
				let pattern = $el.data('val-regex-pattern');
				pattern = pattern.replace("@('@')", '@'); // razor fix
				const val = $el.val();
				let regex = new RegExp(pattern);
				if (!regex.test(val)) {
					$(`[data-valmsg-for="${name}"]`).text($el.data('val-regex'));
					$el.closest('div').addClass('validation-error');
				}
				regex = null;
			}
		}
		window.isInputValidSelector = function ($el) {
			$('[data-val="true"]', $el).each(customValidation);

			return $('.validation-error', $el).length == 0;
		};

		window.isInputValid = function (selector) {
			if (selector == null) {
				selector = 'body';
			}
			// revalidate all inputs
			$('[data-val="true"]', selector).each(customValidation);

			return $('.validation-error', selector).length == 0;
		};
		window.validateAll = function () {
			$('input, textarea').each(customValidation);
		};

		window.jsonReplacer = function (key, value) {
			if (value === null) return undefined;
			return value;
		};

		// global register validation
		$(document).on('change input blur', '[data-val="true"]', customValidation);
	})(jQuery);

	$(document).delegate('.js-allow-textarea-tab', 'keydown', e => {
		const keyCode = e.keyCode || e.which;

		if (keyCode == 9) {
			e.preventDefault();

			/*
            var start = $(this).get(0).selectionStart;
            var end = $(this).get(0).selectionEnd;

            // set textarea value to: text before caret + tab + text after caret
            $(this).val($(this).val().substring(0, start)
                + ""
                + $(this).val().substring(end));

            // put caret at right position again
            $(this).get(0).selectionStart =
                $(this).get(0).selectionEnd = start + 1;
            */
		}
	});

	window.deleteConfirmComponent = function (self, submit, title, question, buttondelete, buttoncancel) {
		return {
			id: 'deleteConfirmation',
			cardtitle: title || 'Delete',
			carddescription: question || 'Are you sure?',
			buttonHasIcon: true,
			buttonIconClass: 'fa-trash-o',
			buttoncolor: 'is-danger',
			buttoncancelcolor: 'is-clean is-primary',
			buttontitle: buttondelete || 'Delete',
			buttoncanceltitle: buttoncancel || 'Cancel',
			onCancel: function () {
				self.modal = null;
			},
			onSubmit: submit
		};
	};
})();

window.vueMountedCreatedMixin = {
	created: function () {
		console.log(this.$options.el, 'created');
		$(this.$options.el).removeClass('is-creating');
		if (!this.noLoader) {
			toggleLoader(true);
		}
	},
	mounted: function () {
		console.log(this.$options.el, 'mounted');
		$(this.$options.el).removeClass('is-mounting');
	}
};

window.vueArrayEditMixin = {
	methods: {
		removeFromArray: function (arr, index) {
			if (window.confirm('Are you sure?')) {
				arr.splice(index, 1);
			}
		},
		addToArray: function (arr, obj) {
			console.log('add to array', arr, obj);
			if (arr == null) {
				arr = [];
			}
			Vue.set(arr, arr.length, obj);
		}
	}
}

window.vueMongoCrudDefaultMixin = {
	data: function () {
		return {
			items: [],
			activeItem: null,
			selectedItem: null,
			modal: null,
			newObject: {},
			filter: null,
			rememberSelected: true
		};
	},
	created: function () {
		this.fetchData();
	},
	methods: {
		fetchData: function () {
			const self = this;
			toggleLoader(true);
			GET(self.endpoint.list).then(xhr => {
				const response = JSON.parse(xhr.responseText);
				self.items = response;
				if (self.rememberSelected) {
					const ix = sessionStorage.getItem(`${self.$options.el}-index`);
					if (ix && ix >= 0 && ix < self.items.length) {
						self.selectItem(self.items[ix], ix);
					}
				}
				toggleLoader(false);
			});
		},
		filterList: function () {
			const self = this;
			if (!self.filter || self.filter == '') {
				$('.js-list-menu-item').removeClass('is-hidden');
			} else {
				$('.js-list-menu-item').each(function () {
					const re = new RegExp(self.filter, 'gi');

					if (re.test($(this).text())) {
						$(this).removeClass('is-hidden');
					} else {
						$(this).addClass('is-hidden');
					}
				});
			}
		},
		selectItem: function (item, ix) {
			console.log('selectItem', item, ix);
			this.activeItem = item;
			if (item != null) {
				const clone = window.cloneObject(item);
				this.selectedItem = clone;
			} else {
				this.selectedItem = null;
			}
			if (this.rememberSelected) {
				sessionStorage.setItem(`${this.$options.el}-index`, ix);
			}
		},
		addItem: function () {
			this.activeItem = null;
			this.selectedItem = window.cloneObject(this.newObject);
			if (this.rememberSelected) {
				sessionStorage.setItem(`${this.$options.el}-index`, this.items.length);
			}
			if (this.addItemCallback) {
				this.addItemCallback();
			}
		},
		saveItem: function () {
			toggleLoader(true);
			const self = this;

			const callback = function () {
				const json = {
					filter: JSON.stringify({ _id: self.selectedItem._id }),
					json: JSON.stringify(self.selectedItem)
				};

				POSTPUTMONGO(self.endpoint.store, json, self.selectedItem._id).then(
					xhr => {
						window.initToast('Saved', 'success');
						console.log(xhr.responseText);
						self.fetchData();
					},
					xhr => {
						window.initToast(xhr.responseText, 'warning');
						toggleLoader(false);
					}
				);
			};

			if (this.preSave) {
				this.preSave(callback);
			} else {
				callback();
			}
		},
		deleteItem: function () {
			console.log('delete item');
			const self = this;
			if (self.selectedItem._id != null) {
				const json = {
					_id: self.selectedItem._id
				};
				console.log('delete', json);
				this.modal = window.deleteConfirmComponent(
					self,
					() => {
						DELETE(`${self.endpoint.store}?filter=${JSON.stringify(json)}`).then(
							xhr => {
								console.log(xhr.responseText);
								window.initToast('Deleted', 'success');
								self.selectItem(null, 0);
								self.modal = null;
								self.fetchData();
							},
							xhr => {
								window.initToast(xhr.responseText, 'warning');
							}
						);
					},
					'Delete',
					'Are you sure?',
					'Delete'
				);
			} else {
				console.log('no selectedItem._id', JSON.stringify(self.selectedItem));
			}
		},
		closemodals: function () {
			this.modal = null;
		}
	}
};

$(document).on('click', '.js-copy-on-click', function () {
	console.log('click it!!!');
	var val = $(this).html();
	const el = document.createElement('textarea');
	el.value = val;
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
	window.initToast('copied to clipboard', 'success');
});

/* Vue Directives ( Should go before Vue Components ) */
require('./directives/escapetoclosemodal.js');
require('./directives/sticky.js');

/* Vue Components ( Should go before Vue Apps ) */
require('./components/_vue-components.js');
